import React from 'react'

import { ContentWithOffset } from '../../components/scharedStyles/style'
import { HISTORY_TABS } from './constants'
import HistoryAuditTab from './HistoryAuditTab'
import HistoryExportTab from './HistoryExportTab'
import HistoryTabs from './HistoryTabs'
import HistoryVersionsTab from './HistoryVersionsTab'
import { useHistoryEffects } from './hooks'
import { Main } from './style'
import { useHistoryTabs } from './HistoryTabs/useHistoryTabs'

const HistoryTabContent = () => {
    const { activeTab } = useHistoryTabs()

    switch (activeTab) {
        case HISTORY_TABS.versions:
            return <HistoryVersionsTab />
        case HISTORY_TABS.audit:
            return <HistoryAuditTab />
        case HISTORY_TABS.export:
        default:
            return <HistoryExportTab />
    }
}

const History = () => {
    useHistoryEffects()

    return (
        <ContentWithOffset>
            <Main>
                <HistoryTabs />
                <HistoryTabContent />
            </Main>
        </ContentWithOffset>
    )
}

export default History
